import useStyling from 'hooks/useStyling';
import React, { InputHTMLAttributes } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
	label?: string;
	name?: string;
	optional?: boolean
	errors?: any[]
}

const Checkbox: React.FC<InputProps> = ({
	type,
	className,
	label,
	name,
	optional = false,
	disabled = false,
	errors,
	...restProps
}) => {

	const [error, setError] = useState<any>()
	const {switchClassNames} = useStyling()

	useEffect( () => {
		if (errors) setError(errors.find(x => x?.propertyPath === name));
		else setError(null)
	}, [errors, name])

	return (
		<div className="flex relative">
			<div className="flex h-5 items-center">
				<input
					id={name}
					name={name}
					type="checkbox"
					disabled={disabled}
					className={switchClassNames(
						error ? 'border-red-700' : 'border-gray-300',
						disabled? 'bg-gray-100 text-gray-500': 'bg-white',
						`${className} form-checkbox h-5 w-5 block placeholder-gray-400 border rounded-md shadow-sm appearance-none focus:outline-none focus:ring-cobalt-500 focus:border-cobalt-500 sm:text-sm checked:bg-cobalt-500 focus:checked:bg-cobalt-500 hover:checked:bg-cobalt-500`
					)}
					{...restProps}
				/>
			</div>
			<div className="ml-2 text-md">
				{label && (
					<label
						htmlFor={name}
						className={switchClassNames(
							error ? 'text-gray-700' : 'text-gray-700',
							'flex items-end justify-between text-sm font-medium'
						)}
					>
						<span>{label}</span>
						{optional && <span className="text-xs text-gray-400">(optional)</span>}
					</label>
				)}
				{error && <span className="pt-1 text-xs text-red-700">{error?.message}</span>}
			</div>
		</div>
	)
}

export default Checkbox
